/* eslint-disable jsx-a11y/img-redundant-alt */
import React,{ useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import './referal.css';
import axios from 'axios';
import { Button } from '@mui/material';
import { GrLocation } from 'react-icons/gr';
import { AiOutlinePhone } from 'react-icons/ai';
import ThankYouReferral from './ThankYouReferral';
import Loader from '../Loader';

const fieldSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#fff' },
};

const submitSx = {
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 500,
  boxShadow: 'none',
  '&:hover': { boxShadow: '0 6px 16px -6px rgba(37, 99, 235, 0.55)' },
};

function SelfReferral({ baseURL }) {
  const {
    linkid,value, templateid, contactid, type,
  } = useParams();
  // console.log('contactid', contactid, type, value);

  const [changemailpage,setChangeEmailpage] = useState(1);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [data, setData] = useState(null);
  const [error, setError] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [newContactId, setNewContactId] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getReferralData();
  },[]);

  const getReferralData = async () => {
    setError('');
    setErrorMessage('');
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/testing/sr/${linkid}?template_id=${templateid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
      // console.log(response, 'get SR res');
      if (response.data.status === 'success') {
        setLoading(false);
        setData(response?.data?.data);
        setMessage(response?.data?.data?.refree_body__emailormobile);
      }
    } catch (err) {
      console.log(err, 'getReferralData res');
    }
  };

  const handleSubmit = async (id) => {
    setLoading(true);
    const formData = {
      first_name: name,
      email,
      phone,
    };
    const res = await axios.put(`${baseURL}/testing/sr/${linkid}?template_id=${templateid}&id=${id}&send_via=${type}`,formData);
    if (res.data.status === 'success') {
      setName('');
      setPhone('');
      setEmail('');
      setNewContactId(res?.data?.data?.lead_contact_id);
      setChangeEmailpage(changemailpage + 1);
      setLoading(false);
    }
    // console.log('handleSubmit res', res);
    if (res.data.status === 'failure') {
      setErrorMessage(res?.data?.message);
      setError(res?.data?.error);
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      {changemailpage === 1 && (
        <div>
          <div className="qs-page">
            <div className="qs-card">
              <div className="qs-card-body space-y-6">
                <div className="space-y-2">
                  <h2 className="text-lg font-semibold tracking-tight text-slate-900">{data?.name}</h2>
                  {data?.full_address !== null && (
                    <div className="flex items-start gap-2 text-sm text-slate-500">
                      <span className="mt-0.5 shrink-0 opacity-70"><GrLocation /></span>
                      <span>
                        {data?.full_address}
                      </span>
                    </div>
                  )}

                  {data?.phone !== null && (
                    <div className="flex items-center gap-2 text-sm text-slate-500">
                      <span className="shrink-0 opacity-70"><AiOutlinePhone /></span>
                      <span>
                        {data?.phone}
                      </span>
                    </div>
                  )}
                </div>
                <div className="flex justify-center">
                  <figure>
                    {data?.referral_image === null ? (null) : (
                      <img src={data?.referral_image} alt="not responding" className="max-h-[350px] w-auto max-w-full rounded-2xl shadow-md ring-1 ring-black/5 sm:max-w-[250px]" />
                    )}
                  </figure>
                </div>

                <div className="qs-title">{data?.refer_heading}</div>

                <div>
                  <p className="qs-subtitle mb-6">
                    Please fill in the information for the friend you would like
                    to refer.
                  </p>
                  <Stack spacing={2}>
                    <TextField
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      variant="outlined"
                      placeholder="Your friend's name"
                      sx={fieldSx}
                    />

                    {value === '4' && (
                    <TextField
                      type="number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      variant="outlined"
                      placeholder="Your friend's phone number"
                      sx={fieldSx}
                    />
                    )}

                    {value === '3' && (
                    <TextField
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      variant="outlined"
                      placeholder="Your friend's email"
                      sx={fieldSx}
                    />
                    )}

                    <p className="rounded-xl bg-slate-50 px-4 py-3 text-[15px] leading-relaxed text-slate-700">
                      {data?.refree_body__emailormobile}
                    </p>

                    <div className="text-sm text-red-600">
                      {errorMessage}
                      {' '}
                      {' '}
                      {error}
                    </div>

                    {value === '3' && (
                    <Button
                      disabled={name?.length < 2 || email?.length < 5 || loading}
                      style={{
                        marginTop: '20px',height: '55px',width: '100%',
                      }}
                      sx={submitSx}
                      variant="contained"
                      className=""
                      onClick={() => handleSubmit(3)}
                    >
                      Send
                    </Button>
                    )}
                    {value === '4' && (
                    <Button
                      disabled={name?.length < 2 || phone?.length < 9 || loading}
                      style={{
                        marginTop: '20px',height: '55px',width: '100%',
                      }}
                      sx={submitSx}
                      variant="contained"
                      className=""
                      onClick={() => handleSubmit(4)}
                    >
                      Send
                    </Button>
                    )}

                  </Stack>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {changemailpage === 2 && (
      <ThankYouReferral
        data={data}
        name={name}
        backtofirstpage={() => setChangeEmailpage(changemailpage - 1)}
        baseURL={baseURL}
        linkid={linkid}
        contactid={contactid}
        templateid={templateid}
        newContactId={newContactId}
      />
      )}

    </div>
  );
}

export default SelfReferral;
